import { enableProdMode, inject, provideZoneChangeDetection, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { routes } from './app/app-routing.module';
import { ErrorHandlingInterceptor } from './app/interceptors/error-handling.interceptor';
import { AwsAuthService } from './app/services/aws-auth.service';
import { TranslationService } from './app/services/translation.service';
import { NotificationService } from './app/services/notification.service';
import { AppRedirectService } from './app/services/app-redirect.service';
import { CrowdinOtaService } from './app/services/crowdin-ota/crowdin-ota.service';
import { WorkbenchModule } from '@workbench/angular';
import { firstValueFrom, tap } from 'rxjs';
import { CountrySelectorComponent } from './app/modules/shared/country-selector/country-selector.component';
import { CountryCodeInterceptor } from './app/interceptors/country-code.interceptor';

if (environment.production) {
    enableProdMode();
}
(function injectCookieBannerScripts() {
    const base = environment.cmmCdnBaseUrl;
    const esmScript = document.createElement('script');
    esmScript.type = 'module';
    esmScript.setAttribute('data-stencil-namespace', 'cookie-banner');
    esmScript.src = `${base}/plugin/cmm-cookie-banner/2-latest/cookie-banner/cookie-banner.esm.js`;
    document.head.appendChild(esmScript);

    const nomoduleScript = document.createElement('script');
    nomoduleScript.setAttribute('nomodule', '');
    nomoduleScript.setAttribute('data-stencil-namespace', 'cookie-banner');
    nomoduleScript.src = `${base}/plugin/cmm-cookie-banner/2-latest/cookie-banner/cookie-banner.js`;
    document.head.appendChild(nomoduleScript);
})();

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlingInterceptor, multi: true },
         { provide: HTTP_INTERCEPTORS, useClass: CountryCodeInterceptor, multi: true },
        importProvidersFrom(TranslateModule.forRoot(), WorkbenchModule),
        AwsAuthService,
        AppRedirectService,
        NotificationService,
        CrowdinOtaService,
        CountrySelectorComponent,
        provideAppInitializer(() => {
            const translationService = inject(TranslationService);
            return firstValueFrom(translationService.getAllFeatureFlags().pipe(
                tap((featureFlags: any) => {
                    translationService.featureFlags = featureFlags;
                })
            ));
        })
    ]
})
.catch((err) => console.error(err));


